import { render, staticRenderFns } from "./Collector.vue?vue&type=template&id=2a125dfe&scoped=true"
import script from "./Collector.vue?vue&type=script&lang=ts"
export * from "./Collector.vue?vue&type=script&lang=ts"
import style0 from "./Collector.vue?vue&type=style&index=0&id=2a125dfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a125dfe",
  null
  
)

export default component.exports